// src/features/testimonials/TestimonialForm.jsx
import React, { useState } from "react";
import "./testimonial-form-page.css";
import { apiPostForm, apiPutForm, API_BASE } from "../../admin/api";
import Editor from "../../admin/components/Editor";

export default function TestimonialForm({ initial, onSaved, onCancel }) {
  const [title, setTitle] = useState(initial?.title || "");
  const [personName, setPersonName] = useState(initial?.person_name || "");
  const [designation, setDesignation] = useState(initial?.designation || "");
  const [status, setStatus] = useState(initial?.status || "published");
  const [message, setMessage] = useState(initial?.message || "");
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!personName.trim() || !message.trim()) {
      alert("Person name and message are required.");
      return;
    }
    try {
      setSaving(true);
      const body = {
        title: title || undefined,
        person_name: personName,
        designation: designation || undefined,
        status,
        message,
      };
      if (image) body.image = image;

      if (initial?.id) {
        await apiPutForm(`/api/testimonials/${initial.id}`, body);
      } else {
        await apiPostForm(`/api/testimonials`, body);
      }
      onSaved?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="t-form-page minimalist">
      <section className="tf-left">
        <div className="card">
          <label className="f">
            <span className="f__label">Title (optional)</span>
            <input
              className="f__input"
              placeholder="Short headline for the testimonial"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>

          <div className="grid-2">
            <label className="f">
              <span className="f__label">Person Name *</span>
              <input
                className="f__input"
                placeholder="e.g., Sita Sharma"
                value={personName}
                onChange={(e) => setPersonName(e.target.value)}
                required
              />
            </label>

            <label className="f">
              <span className="f__label">Designation</span>
              <input
                className="f__input"
                placeholder="e.g., COO, Everest Group"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              />
            </label>
          </div>

          <label className="f">
            <span className="f__label">Message *</span>
            <Editor value={message} onChange={setMessage} />
          </label>
        </div>

        <div className="card">
          <div className="card__title">Photo</div>
          <input
            className="f__input"
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {(initial?.image && !image) && (
            <div className="tf-preview">
              <img src={`${API_BASE}${initial.image}`} alt={initial?.person_name || "photo"} />
            </div>
          )}
        </div>
      </section>

      <aside className="tf-right">
        <div className="card slim">
          <div className="card__title">Publish</div>
          <label className="f">
            <span className="f__label">Status</span>
            <select className="f__input" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="published">Published</option>
              <option value="draft">Draft</option>
            </select>
          </label>

          <div className="row end gap">
            <button type="button" className="btn btn--sm" onClick={onCancel}>Cancel</button>
            <button disabled={saving} className="btn primary">
              {saving ? "Saving..." : (initial ? "Save Changes" : "Add Testimonial")}
            </button>
          </div>
        </div>
      </aside>
    </form>
  );
}
